import React from 'react';
import { Provider as ReduxProvider } from 'react-redux'
import ThemeWrapper from './ThemeWrapper';
import store from '../store';
import './App.css'

store.subscribe(() => {
  console.debug('state', store.getState())
})

function App() {
  return (
    <ReduxProvider store={store}>
      <ThemeWrapper />
    </ReduxProvider>
  );
}

export default App;
